var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#4CAF50"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 14.5994L6.02 15.8356C5.83 16.0058 5.6125 16.0438 5.3675 15.9498C5.1225 15.8557 5 15.6878 5 15.4459V7.07493C5 6.77932 5.1175 6.52627 5.3525 6.31576C5.5875 6.10525 5.87 6 6.2 6H15.8C16.13 6 16.4125 6.10525 16.6475 6.31576C16.8825 6.52627 17 6.77932 17 7.07493V13.5245C17 13.8201 16.8825 14.0731 16.6475 14.2836C16.4125 14.4942 16.13 14.5994 15.8 14.5994H7.4ZM6.89 13.5245H15.8V7.07493H6.2V14.1291L6.89 13.5245ZM8 12.4496H11.6C11.77 12.4496 11.9125 12.398 12.0275 12.295C12.1425 12.192 12.2 12.0644 12.2 11.9121C12.2 11.7598 12.1425 11.6322 12.0275 11.5292C11.9125 11.4261 11.77 11.3746 11.6 11.3746H8C7.83 11.3746 7.6875 11.4261 7.5725 11.5292C7.4575 11.6322 7.4 11.7598 7.4 11.9121C7.4 12.0644 7.4575 12.192 7.5725 12.295C7.6875 12.398 7.83 12.4496 8 12.4496ZM8 10.8372H14C14.17 10.8372 14.3125 10.7857 14.4275 10.6826C14.5425 10.5796 14.6 10.452 14.6 10.2997C14.6 10.1474 14.5425 10.0198 14.4275 9.91676C14.3125 9.81375 14.17 9.76224 14 9.76224H8C7.83 9.76224 7.6875 9.81375 7.5725 9.91676C7.4575 10.0198 7.4 10.1474 7.4 10.2997C7.4 10.452 7.4575 10.5796 7.5725 10.6826C7.6875 10.7857 7.83 10.8372 8 10.8372ZM8 9.22478H14C14.17 9.22478 14.3125 9.17327 14.4275 9.07026C14.5425 8.96724 14.6 8.8396 14.6 8.68731C14.6 8.53503 14.5425 8.40739 14.4275 8.30437C14.3125 8.20136 14.17 8.14985 14 8.14985H8C7.83 8.14985 7.6875 8.20136 7.5725 8.30437C7.4575 8.40739 7.4 8.53503 7.4 8.68731C7.4 8.8396 7.4575 8.96724 7.5725 9.07026C7.6875 9.17327 7.83 9.22478 8 9.22478Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentCircleIcon);
export default __webpack_public_path__ + "static/media/comment-circle-icon.2d9140daeaf30c4406e09029b6c16fe3.svg";
export { ForwardRef as ReactComponent };